/*
  <div x-data="horizontalSlider">
    <button @click="showPrevious">Zurück</button>
    <button @click="showNext">Weiter</button>
    <ul x-ref="carouselItems">
      <li class="carousel-item"></li>
    </ul>
    <!-- optional: position indicator -->
    <div class="tabs-carousel-dots">
        <template x-for="i in items?.length">
            <li :class="{ dot: true, active: i === currentPosition }"></li>
        </template>
    </div>

   <!-- or by iterating in the html template -->
   <div x-data="horizontalSlider" x-effect="updateIndicators(currentPosition)">
      …
      <ul x-ref="indicatorsItems">
          <li class="dot"></li>
          <li class="dot"></li>
          <li class="dot"></li>
      </ul>
   </div>
 </div>
 */

import './HorizontalSlider.scss';

export const horizontalSlider = {
  init() {
    this.currentPosition = null;
    this.scrollObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // target is the current scrolled in question
        const { target } = entry;
        if (entry.intersectionRatio >= 0.5) {
          target.classList.add('current');
          let pos = target.dataset.position;
          this.currentPosition = Number(pos);
        } else {
          target.classList.remove('current');
        }
      });
    }, {
      // rootMargin: "0px",
      threshold: 0.5,
    });
    this.items = this.$refs.carouselItems.querySelectorAll(':scope > *');

    this.items.forEach((el, i) => {
      this.scrollObserver.observe(el);
      if (el.dataset.position === undefined) {
        el.dataset.position = i + 1;
      }
    });
    if (this.items.length < 2) {
      this.$refs.carouselItems.parentElement.parentElement.classList.add('horizontalSlider-no-controls');
    }
  },
  scrollBehavior() {
    return 'auto';
  },
  show(position) {
    /* `position` starts at 1, not 0 */
    let selected = [...this.$refs.carouselItems.children][position - 1];
    if (!selected) {
      return;
    }
    this.currentPosition = position;
    this.$refs.carouselItems.scrollTo({
      left: selected.offsetLeft,
      behavior: this.scrollBehavior(),
    });
  },
  showPrevious() {
    let children = [...this.$refs.carouselItems.children];
    const current = this.$refs.carouselItems.querySelector('.current');
    if (!current) {
      return;
    }
    let previous = current.previousElementSibling;
    if (!previous) {
      previous = children[children.length - 1];
      this.currentPosition = children.length;
    }
    this.currentPosition = Number(previous.dataset.position);
    let left = previous.offsetLeft;
    this.$refs.carouselItems.scrollTo({
      left,
      behavior: this.scrollBehavior(),
    });
  },
  showNext() {
    let children = [...this.$refs.carouselItems.children];
    let current = children[this.currentPosition - 1];
    if (!current) {
      return;
    }
    let next = children[this.currentPosition];
    this.currentPosition++;
    if (!next) {
      next = children[0];
      this.currentPosition = 1;
    }
    let left = next.offsetLeft;
    this.$refs.carouselItems.scrollTo({
      left,
      behavior: this.scrollBehavior(),
    });
  },
  // this can be used with `x-effect="updateIndicators(currentPosition)"` and `<ul x-ref="indicatorsItems">`
  updateIndicators(currentPosition) {
    [...this.$refs.indicatorsItems?.children].forEach((el, i) => {
      if (i + 1 === currentPosition) {
        el.classList.add('active');
      } else {
        el.classList.remove('active');
      }
    });
  }
};